import React, { useEffect, useState } from 'react';
import './SystemBanner.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useGlobalOptions } from './GlobalOptionsContext';

const DISMISSED_KEY = 'system-banner-dismissed';

export const SystemBanner: React.FC = () => {
    const { getSystemBanner } = useGlobalOptions();
    const banner = getSystemBanner();
    const [isDismissed, setIsDismissed] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if this banner version was dismissed
        if (banner && banner.updatedAt) {
            const dismissedTimestamp = localStorage.getItem(DISMISSED_KEY);
            if (dismissedTimestamp) {
                const dismissed = parseInt(dismissedTimestamp, 10);
                // If the banner was updated after it was dismissed, show it again
                setIsDismissed(banner.updatedAt <= dismissed);
            } else {
                setIsDismissed(false);
            }
        } else {
            setIsDismissed(false);
        }
    }, [banner]);

    useEffect(() => {
        // Show banner if it's active, has a message, and hasn't been dismissed
        setIsVisible(
            banner?.isActive === true &&
            !!banner?.message &&
            !isDismissed
        );
    }, [banner, isDismissed]);

    const handleDismiss = () => {
        if (banner?.updatedAt) {
            localStorage.setItem(DISMISSED_KEY, banner.updatedAt.toString());
        }
        setIsDismissed(true);
    };

    if (!isVisible || !banner) {
        return null;
    }

    const variant = banner.variant || 'info';

    return (
        <div className={`system-banner system-banner-${variant}`}>
            <div className="system-banner-content">
                <div className="system-banner-icon">
                    {variant === 'info' && <FontAwesomeIcon icon={faInfoCircle} />}
                    {variant === 'warning' && <FontAwesomeIcon icon={faExclamationTriangle} />}
                    {variant === 'danger' && <FontAwesomeIcon icon={faExclamationTriangle} />}
                </div>
                <div className="system-banner-message">
                    {banner.message}
                </div>
            </div>
            <button
                className="system-banner-dismiss"
                onClick={handleDismiss}
                aria-label="Dismiss"
            >
                <FontAwesomeIcon icon={faTimes} size='sm' />
            </button>
        </div>
    );
};
